"use client";

import { Heading, HeadingProps } from "@chakra-ui/react";
import { FC } from "react";

type Props = {
  children: string;
} & HeadingProps;

const PageTitle: FC<Props> = ({ children, ...props }) => (
  <Heading as="h1" size="3xl" mb={4} {...props}>
    {children}
  </Heading>
);

export default PageTitle;
